import { MODULOS, type IdModulo } from './modulos'
import type { ModoLayout } from './useModoLayout'

interface Props {
  moduloAtual: IdModulo
  aoTrocar: (id: IdModulo) => void
  modoLayout: ModoLayout
}

/**
 * Navegação entre os módulos. É a mesma em toda a aplicação — não existe
 * uma barra por módulo, e o usuário não reaprende onde clicar ao trocar de
 * assunto.
 *
 * No desktop e no tablet mostra ícone + texto. No mobile o texto sai e sobra o
 * ícone, com o nome do módulo em `aria-label` e em `title`: nessa largura a
 * faixa rola na horizontal, e rótulo por extenso deixaria dois módulos visíveis
 * por vez.
 */
export function NavegacaoModulos({ moduloAtual, aoTrocar, modoLayout }: Props) {
  const somenteIcone = modoLayout === 'mobile'

  return (
    <nav
      className={`menu-horizontal${somenteIcone ? ' menu-horizontal--compacto' : ''}`}
      aria-label="Módulos do laboratório"
    >
      {MODULOS.map((modulo) => {
        const ativo = modulo.id === moduloAtual
        return (
          <button
            key={modulo.id}
            type="button"
            className={ativo ? 'item-menu-horizontal ativo' : 'item-menu-horizontal'}
            onClick={() => aoTrocar(modulo.id)}
            aria-current={ativo ? 'page' : undefined}
            aria-label={somenteIcone ? modulo.rotulo : undefined}
            title={modulo.titulo}
          >
            <modulo.Icone tamanho={18} />
            {!somenteIcone && <span>{modulo.rotulo}</span>}
          </button>
        )
      })}
    </nav>
  )
}
